import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon EmproveIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const EmproveIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 11.6 14.8">
      <g>
        <g id="Layer_1">
          <g id="Group_2985">
            <g id="Line_9">
              <path d="M1,14.8c-.6,0-1-.4-1-1v-4.5c0-.6.4-1,1-1s1,.4,1,1v4.5c0,.6-.4,1-1,1Z" />
            </g>
            <g id="Line_10">
              <path d="M5.8,14.8c-.6,0-1-.4-1-1V5.3c0-.6.4-1,1-1s1,.4,1,1v8.5c0,.6-.4,1-1,1Z" />
            </g>
            <g id="Line_11">
              <path d="M10.6,14.8c-.6,0-1-.4-1-1V1c0-.6.4-1,1-1s1,.4,1,1v12.8c0,.6-.4,1-1,1Z" />
            </g>
          </g>
        </g>
      </g>
    </Icon>
  )
}
export default EmproveIcon
